import { formatTaskTypeLabel } from "../whiteboard/utils/taskTypeLabels";

export const ALL_TASK_TYPES_GENERATION_OPTIONS = Object.freeze({
  allTypes: true,
});

export function buildTaskTypeChoices(tasks) {
  return (Array.isArray(tasks) ? tasks : []).map((task, index) => {
    const type = String(task?.type || `task_${index}`);
    return {
      key: `${index}::${type}`,
      type,
      index,
      label: `${index + 1}. ${formatTaskTypeLabel(type, index)}`,
    };
  });
}

export function normalizeTaskGenerationModes(adapter) {
  const source = Array.isArray(adapter?.generationModes) ? adapter.generationModes : [];
  const modes = source
    .map((mode, index) => {
      const value = String(mode?.value || `mode_${index}`);
      return {
        value,
        label: String(mode?.label || value),
        generationOptions:
          mode?.generationOptions && typeof mode.generationOptions === "object"
            ? { ...mode.generationOptions }
            : value
              ? { variant: value }
              : null,
      };
    })
    .filter((mode) => mode.value);

  const existingAllTypes = modes.find(
    (mode) => mode.value === "all_types" || mode?.generationOptions?.allTypes
  );
  if (existingAllTypes) {
    existingAllTypes.value = "all_types";
    existingAllTypes.label = "Wszystkie typy zadań";
    existingAllTypes.generationOptions = {
      ...(existingAllTypes.generationOptions || {}),
      ...ALL_TASK_TYPES_GENERATION_OPTIONS,
    };
  } else if (typeof adapter?.generateTasks === "function") {
    modes.unshift({
      value: "all_types",
      label: "Wszystkie typy zadań",
      generationOptions: { ...ALL_TASK_TYPES_GENERATION_OPTIONS },
    });
  }

  return modes;
}
